import { GetLanguage } from '@utils/language';
import { encryption } from '@utils/encryption';
import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, errorResponse } from '@utils/response';
import { Token, UserCode, AccessType, IsSupervisorMode } from '@users';
import { format, formatDate } from '@utils';
import { reportTypes } from '@utils/reportHelper';
import i18next from 'i18next';

const CONTROLLER_ROUTE = IsSupervisorMode() ? 'Supervisor/' : '';

export function getReportDefinition(reportType, reportParameters) {

	const url = CONTROLLER_ROUTE + 'report/getReportDefinition';

	const param = {};

	param.language = GetLanguage();
	param.accessTypeCrypt = encryption(AccessType());
	param.userCodeCrypt = encryption(UserCode());
	param.reportTypeCrypt = encryption(reportType);
	param.reportParametersCrypt = encryption(reportParameters);
	param.token = Token();

	return fetch(url, {
		method: 'post',
		credentials: 'include',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(param)
	})
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getReportTitleByReportType(type, reportParameters) {
    switch (type) {
		case reportTypes.LIST_EMPLOYEES_BY_SENIORITY:
			return i18next.t("report:title.list_employees_by_seniority");
		case reportTypes.LIST_EMERGENCY_CONTACTS_BY_EMP_DEPT:
			return i18next.t("report:title.list_emergency_contacts_by_emp_dept");
		case reportTypes.LIST_EMPLOYEES:
			return format(i18next.t("report:title.list_employees"), formatDate(new Date(), 'date'));
		case reportTypes.LIST_EMPLOYEES_FILTERED:
			return format(i18next.t("report:title.list_employees_filtered"), formatDate(new Date(), 'date'));
		case reportTypes.SENIORITY_BY_EMP:
			return i18next.t("report:title.seniority_by_emp");
		case reportTypes.EMPLOYEE_DS:
			return i18next.t("report:title.employee_ds");
		case reportTypes.EMPLOYEE_COMMENT_LIST_BY_SUBCODE_GROUPMENT:
			return i18next.t("report:title.employee_comment_list_by_subcode_groupment");
		case reportTypes.DETAIL_TS_ENTRIES_BY_SITE_DEPT_PAY_ACTIVITY:
			return i18next.t("report:title.detail_ts_entries_by_site_dept_pay_activity");
		case reportTypes.SUMMARY_TS_ENTRIES_BY_SITE_DEPT_PAY_ACTIVITY:
			return i18next.t("report:title.summary_ts_entries_by_site_dept_pay_activity");
		case reportTypes.SUMMARY_TS_ENTRIES_BY_SITE_DEPT:
			return i18next.t("report:title.summary_ts_entries_by_site_dept");
		case reportTypes.DETAIL_TS_ENTRIES_BY_SITE_DEPT:
			return i18next.t("report:title.detail_ts_entries_by_site_dept");
		case reportTypes.TS_ENTRIES_BY_EMP_DEPT_PAY_PER:
			return i18next.t("report:title.ts_entries_by_emp_dept_pay_per");
		case reportTypes.MISSING_TS_BY_EMP_DEPT_PAY_PER:
			return i18next.t("report:title.missing_ts_by_emp_dept_pay_per");
		case reportTypes.SCHEDULE_TIME_ENTRIES_FROM_TS: {

			if (!reportParameters.annee_paie
				|| !reportParameters.periode_paie) {
				return "Missing parameter one or more parameters";
			}

			return format(i18next.t("report:title.schedule_time_entries_from_ts"), reportParameters.annee_paie, reportParameters.periode_paie);
		}
		case reportTypes.TS_ENTRIES_BY_PROJ_DEPT_EMP_PAY_PERIOD:
			return i18next.t("report:title.ts_entries_by_proj_dept_emp_pay_period");
		case reportTypes.TS_PUNCH_HOURS_DISPARITY:
			return i18next.t("report:title.ts_punch_hours_disparity");
		case reportTypes.VALIDATION_TS_WITH_PRODUCTION_ORDERS:
			return i18next.t("report:title.validation_ts_with_production_orders");
		case reportTypes.OVERTIME_VALIDATION_TS:
			return i18next.t("report:title.overtime_validation_ts");
		case reportTypes.WEEKLY_TS:
			return i18next.t("report:title.weekly_ts");
		case reportTypes.SUMMARY_WEEKLY_TS:
			return i18next.t("report:title.summary_weekly_ts");
		case reportTypes.SUBCODES_BY_PAY_PROJ_EMP:
			return i18next.t("report:title.subcodes_by_pay_proj_emp");
		case reportTypes.PROJECT_HOURS_ABC:
			return i18next.t("report:title.project_hours_abc");
		case reportTypes.TS_ENTRIES_BY_EMP_DEPT_PAY_PER_WITH_APPROVAL:
			return i18next.t("report:title.ts_entries_by_emp_dept_pay_per_with_approval");
		case reportTypes.GET_HOURS_BY_PROJECT_BETWEEN_2_DATES: {

			if (!reportParameters.date_debut
				|| !reportParameters.date_fin) {
				return "Missing parameter one or more parameters";
			}

			return format(i18next.t("report:title.get_hours_by_project_between_2_dates"), formatDate(reportParameters.date_debut, 'date'), formatDate(reportParameters.date_fin, 'date'));
		}
		case reportTypes.SCHEDULE_TIME_ENTRIES_FROM_PUNCH:
			return i18next.t("report:title.schedule_time_entries_from_punch");
		case reportTypes.SCHEDULE_TIME_ENTRIES_FROM_PUNCH_DEPT:
			return i18next.t("report:title.schedule_time_entries_from_punch_dept");
		case reportTypes.DAILY_PUNCH_BY_EMP_DEPT:
			return i18next.t("report:title.daily_punch_by_emp_dept");
		case reportTypes.PUNCH_PER_DATE:
			return i18next.t("report:title.punch_per_date");
		case reportTypes.PUNCH_BY_APPROV_PROJ_DATE:
			return i18next.t("report:title.punch_by_approv_proj_date");
		case reportTypes.SCHEDULE_TIME_ENTRIES_FROM_PUNCH_DEPT_BTW_TWO_DATES: {

			if (!reportParameters.date_debut
				|| !reportParameters.date_fin) {
				return "Missing parameter one or more parameters";
			}

			return format(i18next.t("report:title.schedule_time_entries_from_punch_dept_btw_two_dates"), formatDate(reportParameters.date_debut, 'date'), formatDate(reportParameters.date_fin, 'date'));
		}
		case reportTypes.TS_AND_PUNCH_HOURS_DISPARITY:
			return i18next.t("report:title.ts_and_punch_hours_disparity");
		case reportTypes.DELAYS_AND_EARLY_DEPARTURES:
			return i18next.t("report:title.delays_and_early_departures");
		case reportTypes.WEEKLY_PUNCH_ENTRIES:
			return i18next.t("report:title.weekly_punch_entries");
		case reportTypes.OVERTIME_VALIDATION:
			return i18next.t("report:title.overtime_validation");
		case reportTypes.FLOOR_PRODUCTIVITY:
			return i18next.t("report:title.floor_productivity");
		case reportTypes.SUMMARY_PUNCH_BY_PROJ_TIMECODE_JOBTITLE:
			return i18next.t("report:title.summary_punch_by_proj_timecode_jobtitle");
		case reportTypes.PUNCH_DATE_APPROV_ACT:
			return i18next.t("report:title.punch_date_approv_act");
		case reportTypes.PUNCH_DATE_APPROV_ACT_PUNCHED:
			return i18next.t("report:title.punch_date_approv_act_punched");
		case reportTypes.PLANNING_AND_ACTUAL_PUNCH_DISPARITY:
			return i18next.t("report:title.planning_and_actual_punch_disparity");
		case reportTypes.HOURS_BY_OCCUPATION_WORKED_BY_EMP:
			return i18next.t("report:title.hours_by_occupation_worked_by_emp");
		case reportTypes.BILLING_FROM_PAYROLL:
			return i18next.t("report:title.billing_from_payroll");
		case reportTypes.POINTS_BY_DATE_WITH_ABC_PROJECT:
			return i18next.t("report:title.points_by_date_with_abc_project");
		case reportTypes.HOURS_BY_PROJ:
			return i18next.t("report:title.hours_by_proj");
		case reportTypes.DAILY_HTP_PUNCH_DEVIATION_ABC:
			return i18next.t("report:title.daily_htp_punch_deviation_abc");
		case reportTypes.ABC_PROJECT_HOURS_REPORT:
			return i18next.t("report:title.abc_project_hours_report");
		case reportTypes.HOURS_WORKED_BY_PROJECTS: {

			if (!reportParameters.date_debut
				|| !reportParameters.date_fin) {
				return "Missing parameter one or more parameters";
			}

			return format(i18next.t("report:title.hours_worked_by_projects"), formatDate(reportParameters.date_debut, 'date'), formatDate(reportParameters.date_fin, 'date'));
		}
		case reportTypes.NUMBER_OF_DAYS_AWAY_REPORT:
			return i18next.t("report:title.number_of_days_away_report");
		case reportTypes.EMPLOYEE_SCHEDULE_BY_SECTOR:
			return i18next.t("report:title.employee_schedule_by_sector");
		case reportTypes.SUMMARY_EMPLOYEE_SCHEDULE_BY_DEPT:
			return i18next.t("report:title.summary_employee_schedule_by_dept");
		case reportTypes.EMPLOYEE_SCHEDULE_BY_APPROV_DEPT:
			return i18next.t("report:title.employee_schedule_by_approv_dept");
		case reportTypes.EMPLOYEE_SCHEDULE_BY_PROJECT:
			return i18next.t("report:title.employee_schedule_by_project");
		case reportTypes.HOURS_BY_DEPT:
			return i18next.t("report:title.hours_by_dept");
		case reportTypes.HOURS_BY_DEPT_BY_JOBTITLE:
			return i18next.t("report:title.hours_by_dept_by_jobtitle");
		case reportTypes.EMPLOYEE_SCHEDULE_BY_SHIFT:
			return i18next.t("report:title.employee_schedule_by_shift");
		case reportTypes.EMPLOYEE_SCHEDULE_WITH_RANGE_DESC:
			return i18next.t("report:title.employee_schedule_with_range_desc");
		case reportTypes.EMPLOYEE_SCHEDULE_BY_DEPT_AND_LOCATION:
			return i18next.t("report:title.employee_schedule_by_dept_and_location");
		case reportTypes.EMPLOYEE_SCHEDULE_BY_DEPT:
			return i18next.t("report:title.employee_schedule_by_dept");
		case reportTypes.NBR_HOURS_PLAN_BY_DEP_WORKSHIFT:
			return i18next.t("report:title.nbr_hours_plan_by_dep_workshift");
		case reportTypes.NBR_HOURS_PLAN_BY_DEP_WORK_SHIFT_ATTENDANCE_LIST:
			return i18next.t("report:title.nbr_hours_plan_by_dep_work_shift_attendance_list");
		case reportTypes.NBR_ACTUAL_HOURS_BY_DEP_WORK_SHIFT:
			return i18next.t("report:title.nbr_actual_hours_by_dep_work_shift");
		case reportTypes.CALENDAR_ABSENCES:
			return i18next.t("report:title.calendar_absences");
		case reportTypes.OVERTIME:
			return i18next.t("report:title.overtime");
		case reportTypes.TIMESHEET_HOURS_BY_DEPARTMENT_PAY_ACTIVITY_PROJECT:
			return i18next.t("report:title.timesheet_hours_by_department_pay_activity_project");
		case reportTypes.TIMESHEET_MONTHLY_HOURS_BY_DEPARTMENT_PAY_ACTIVITY_PROJECT:
			return i18next.t("report:title.timesheet_monthly_hours_by_department_pay_activity_project");
		case reportTypes.HOURLY_REPORT:
			return i18next.t("report:title.hourly_report");
		case reportTypes.SCHEDULE_TIME_ENTRIES_FROM_PUNCHTIME:
			return i18next.t("report:title.schedule_time_entries_from_punchtime");
		case reportTypes.ELIGIBLE_BANKBALANCE_FOR_PAYMENT_REQUESTS:
			return i18next.t("report:title.eligible_bankbalance_for_payment_requests");
		case reportTypes.DETAIL_HOUR_BY_SUBCODES:
			return i18next.t("report:title.detail_hour_by_subcodes");
		case reportTypes.DETAIL_TS_PUNCH_ENTRIES_BY_EMP:
			return i18next.t("report:title.detail_ts_punch_entries_by_emp");
		case reportTypes.PUNCH_TS_ENTRIES:
			return i18next.t("report:title.punch_ts_entries");
		case reportTypes.TIMESHEET:
			return i18next.t("report:title.timesheet");
		case reportTypes.TIMESHEET_TASK:
			return i18next.t("report:title.timesheet_task");
		case reportTypes.PERFORMANCE_EVALUATION_EMPLOYEE:
			return i18next.t("report:title.performance_evaluation_employee");
		case reportTypes.PERFORMANCE_EVALUATION_SUPERVISOR:
			return i18next.t("report:title.performance_evaluation_supervisor");
		case reportTypes.PERFORMANCE_EVALUATION_COMPARATIVE:
			return i18next.t("report:title.performance_evaluation_comparative");
		case reportTypes.DAILY_PUNCH_ENTRIES:
			return i18next.t("report:title.daily_punch_entries");
		case reportTypes.PUNCHED_HOURS_AND_HOURS_ENTERED_DISPARITY:
			return i18next.t("report:title.punched_hours_and_hours_entered_disparity");
		case reportTypes.WEEKLY_PUNCH_SPREADSHEET: {

			if (!reportParameters.arg_histo) {
				return "Missing parameter one or more parameters";
			}

			if (reportParameters.arg_histo === 'O') {
				return i18next.t("report:title.weekly_punch_spreadsheet_histo");
            } else {
				return i18next.t("report:title.weekly_punch_spreadsheet");
			}
		}
		case reportTypes.LIST_EMPLOYEES_PRESENT:
			return i18next.t("report:title.list_employees_present");
		case reportTypes.PUNCH_PER_DATE_EMPLOYEE:
			return i18next.t("report:title.punch_per_date_employee");
		case reportTypes.ANNEXA:
			return i18next.t("report:title.annexa");
		case reportTypes.PAYROLL_BANK_ACCRUAL:
			return i18next.t("report:title.payroll_bank_accrual");
		case reportTypes.NON_BILLABLE_HOURS:
			return i18next.t("report:title.non_billable_hours");
		case reportTypes.NON_BILLABLE_TRAINING_HOURS:
			return i18next.t("report:title.non_billable_training_hours");
		case reportTypes.NON_BILLABLE_MILEAGE:
			return i18next.t("report:title.non_billable_mileage");
		case reportTypes.PUNCH_SCHEDULE_CONFLICTS:
			return i18next.t("report:title.punch_schedule_conflicts");
		case reportTypes.PLANNED_AND_PUNCHED_HOURS_DIFFERENCE:
			return i18next.t("report:title.planned_and_punched_hours_difference");
		case reportTypes.SCHEDULE_BY_PROJECT_GARDIUM:
			return i18next.t("report:title.schedule_by_project_gardium");
		case reportTypes.PAYROLL_ENTRIES_VALIDATION:
			return i18next.t("report:title.payroll_entries_validation");
		case reportTypes.YEAR_VACANCY:
			return i18next.t("report:title.year_vacancy");
		case reportTypes.DEVISE:
			return i18next.t("report:title.devise");
		case reportTypes.PERSONAL_CONTACT_REPORT:
			return i18next.t("report:title.personal_contact_report");
		case reportTypes.EMERGENCY_CONTACT:
			return i18next.t("report:title.emergency_contact");
		case reportTypes.MONTHLY_PAYROLL_SUMMARY_JOURNAL:
			return i18next.t("report:title.monthly_payroll_summary_journal");
		case reportTypes.LIST_INACTIVE_EMPLOYEES_BANKBALANCE:
			return i18next.t("report:title.list_inactive_employees_bankbalance");
		case reportTypes.LIST_INVALID_SOCIAL_INSURANCE_NUMBERS:
			return i18next.t("report:title.list_invalid_social_insurance_numbers");
		case reportTypes.PAYROLL_CALENDARS:
			return i18next.t("report:title.payroll_calendars");
		case reportTypes.KONEK_EMPLOYEE_ACCESS:
			return i18next.t("report:title.konek_employee_access");
		case reportTypes.KONEK_EMPLOYEE:
			return i18next.t("report:title.konek_employee");
		case reportTypes.DESIGNER_HOURS_PER_PROJECT_ACTIVITY:
			return i18next.t("report:title.designer_hours_per_project_activity");
		case reportTypes.TIMESHEET_TASK_DRUIDE:
			return i18next.t("report:title.timesheet_task_druide");
		case reportTypes.PUNCH_TS_ENTRIES_DRUIDE:
			return i18next.t("report:title.punch_ts_entries_druide");
		case reportTypes.VACATION_ABSENCE_CALENDAR:
			return i18next.t("report:title.vacation_absence_calendar");
		case reportTypes.SUMMARY_REPORT_HOURS_BY_ABC_PROJECT_TS:
			return i18next.t("report:title.summary_report_hours_by_abc_project_ts");
		case reportTypes.SUMMARY_REPORT_HOURS_BY_ABC_PROJECT_PUNCH:
			return i18next.t("report:title.summary_report_hours_by_abc_project_punch");
		case reportTypes.WEEKLY_PUNCH_BY_PROJ_EMP:
			return i18next.t("report:title.weekly_punch_by_proj_emp");
		case reportTypes.SUMMARY_PUNCH_DATE_APPROV_ACT:
			return i18next.t("report:title.summary_punch_date_approv_act");
		case reportTypes.HOURS_VALIDATION_CONTRACT_TEMPLATES_BY_PROJ:
			return i18next.t("report:title.hours_validation_contract_templates_by_proj");
		case reportTypes.EXTERNAL_TS_AND_ACTUAL_PUNCH_DISPARITY:
			return i18next.t("report:title.external_ts_and_actual_punch_disparity");
		case reportTypes.VALID_HOURS_TO_SHIFT_PLAN_MODELS_BY_PROJ_PER:
			return format(i18next.t("report:title.valid_hours_to_shift_plan_models_by_proj_per"), formatDate(reportParameters.date_debut, 'date'), formatDate(reportParameters.date_fin, 'date'));
		case reportTypes.EMPLOYEE_SCHEDULE_BY_POS_PER: {

			if (!reportParameters.premiere_periode_paie
				|| !reportParameters.derniere_periode_paie) {
				return "Missing parameter one or more parameters";
			}

			// TODO : get start_period and end_period from cal_paie with filter
			// periode_paie == reportParameters.premiere_periode_paie
			// periode_paie == reportParameters.derniere_periode_paie
			// and finally :
			// return format(i18next.t("report:title.employee_schedule_by_pos_per"), formatDate(start_period, 'date'), formatDate(end_period, 'date'));
			return i18next.t("report:title.employee_schedule_by_pos_per");
		}
		case reportTypes.PLANNED_DAILY_PRESENCE_BY_DATE: {

			if (!reportParameters.date_donnee) {
				return "Missing parameter one or more parameters";
			}

			return format(i18next.t("report:title.planned_daily_presence_by_date"), formatDate(reportParameters.date_donnee, 'date'));
		}
		case reportTypes.PAYROLL_SUMMARY_JOURNAL_PAYROLL_PROCESSING:
			return i18next.t("report:title.payroll_summary_journal_payroll_processing");
		case reportTypes.PAYROLL_SUMMARY_JOURNAL_BY_PROJECT:
			return i18next.t("report:title.payroll_summary_journal_by_project");
		case reportTypes.PAYROLL_SUMMARY_JOURNAL_BY_DEPT:
			return i18next.t("report:title.payroll_summary_journal_by_dept");
		case reportTypes.SALARY_JOURNAL_WITH_EMPLOYERS_SHARES:
			return i18next.t("report:title.salary_journal_with_employers_shares");
		case reportTypes.DAILY_REPORT:
			return i18next.t("report:title.daily_report");
		case reportTypes.EVENT_REPORT:
			return i18next.t("report:title.event_report");
        default:
            return "Report title not defined";
    }
}